<template>
  <el-breadcrumb separator=">" class="news-breadcrumb">
    <el-breadcrumb-item :to="{ path: fromPath }">新闻列表</el-breadcrumb-item>
    <el-breadcrumb-item>{{ pageName }}</el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script>
export default {
  props: {
    fromPath: {
      type: String,
      default: "/news",
    },
  },
  data() {
    return {
      pageId: this.$route.query.id,
    };
  },
  computed: {
    pageName() {
      return this.$route.meta.title;
    },
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="less">
.news-breadcrumb {
  color: #666666;
  line-height: 20px;
  margin: 20px 0px 30px 0px;
  font-size: 14px;
  font-weight: 400;
}

@media screen and (max-width: 960px) {
  .breadcrumb {
    display: none;
  }
}
</style>